// create context for auth
import React, { createContext, FC, ReactNode, useEffect, useState } from 'react';

export type AuthContextType = {
    token: string | null;
    logout: () => void;
};

// create context
export const AuthContext = createContext<AuthContextType | null>(null);

// create provider
export const AuthProvider = ({ children }: { children: ReactNode }) => {
    const [token, setToken] = useState<string | null>(null);

    const checkAuthTokenInLocationQuery = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('access_token');
        if (token) {
            // write to local storage
            localStorage.setItem('access_token', token);

            setToken(token);
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }

    const checkAuthTokenInLocalStorage = () => {
        const token = localStorage.getItem('access_token');
        if (token) {
            setToken(token);
        }
    }

    const logout = () => {
        setToken(null);
    };

    // check for token in location query
    // if token is present, set it in state and remove from URL
    useEffect(() => {
        checkAuthTokenInLocationQuery();
        checkAuthTokenInLocalStorage();
    }, []);

    return (
        <AuthContext.Provider value={{ token, logout }}>
            {children}
        </AuthContext.Provider>
    );
}
